import { StatusBar } from "expo-status-bar";
import { Platform, StyleSheet } from "react-native";
import QRCode from "react-native-qrcode-svg";
import { Text, View } from "../components/Themed";
import { getStack } from "../constants/Stacks";

const stack = getStack();

function getRouteCode(tableCode, tableToken) {
  const code = tableCode == null ? "" : String(tableCode).trim().toUpperCase();
  const token = tableToken == null ? "" : String(tableToken).trim().toUpperCase();
  return code || token;
}

export default function ModalScreen({ navigation, route }) {
  const tableId = route.params.tableId;
  const tableToken = route.params.tableToken;
  const tableNumber = route.params.tableNumber;
  const tableCode = route.params.tableCode;
  const computerId = route.params.computerId;
  const computerToken = route.params.computerToken;
  const routeTableCode = getRouteCode(tableCode, tableToken);
  const tableQrValue = tableNumber && routeTableCode
    ? `${stack.web}/tables/${tableNumber}/${routeTableCode}`
    : `${stack.web}/menu/tables/${tableId}/token/${tableToken}`;

  return (
    <View style={styles.container}>
      {((tableNumber && routeTableCode) || (tableId && tableToken)) && (
        <>
          <QRCode
            value={tableQrValue}
            size={256}
          />
          <Text style={styles.tokenText}>{routeTableCode || tableToken}</Text>
        </>
      )}
      {computerId && computerToken && (
        <>
          <QRCode
            value={`${stack.web}/menu/computers/${route.params.computerId}/token/${route.params.computerToken}`}
            size={256}
          />
          <Text style={styles.tokenText}>{computerToken}</Text>
        </>
      )}
      {/* Use a light status bar on iOS to account for the black space above the modal */}
      <StatusBar style={Platform.OS === "ios" ? "light" : "auto"} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  tokenText: {
    marginTop: 24,
    fontSize: 32,
    fontWeight: "bold",
    letterSpacing: 4,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: "80%",
  },
});
